export const namespaced = true

export const state = {
  organization: { id: 1, name: 'Listen360 - Alpharetta, GA' }
}

export const mutations = {
  SET_ORGANIZATION(state, organization) {
    state.organization = organization
  },
  UNSET_ORGANIZATION(state) {
    state.organization = { id: 1, name: 'Listen360 - Alpharetta, GA' }
  }
}

export const actions = {
  setOrganization({ commit }, organization) {
    commit('SET_ORGANIZATION', organization)
  }
}
